import { getAvailableSlashCommandsQueryKey } from '#pplx/frontend/apps/ask/commands/commandsKeys.js';
import { listAvailableSlashCommands } from '#pplx/frontend/apps/ask/commands/hooks/internal/listAvailableSlashCommands.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
const EMPTY_COMMANDS = [];
export const useAvailableSlashCommands = ({ enabled = true, } = {}) => {
    const query = useQuery({
        queryKey: getAvailableSlashCommandsQueryKey(),
        queryFn: () => listAvailableSlashCommands('use-available-slash-commands-hook'),
        enabled,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
    return {
        commands: query.data?.commands ?? EMPTY_COMMANDS,
        isLoading: query.isLoading,
        error: query.error,
    };
};
//# sourceMappingURL=useAvailableSlashCommands.js.map